import React,{Component} from "react";
// import SplitViewSideBarToggle from "../../SplitViewSideBarToggle";
// import Icons from "../../Icons/Icons";
import LeftContainer from '../../../Containers/EmailContainer/EmailTemplate/LeftContainer';
import PdfTagList from '../../../Containers/PDFContainer/PDFCreate/HtmlContent/PdfTagList';
import PdfWindowFieldTagList from '../../../Containers/PDFContainer/PDFCreate/HtmlContent/PdfWindowFieldTagList';
import VariablesList from '../../../Containers/WindowsContainer/VariablesList';

class RightSideBarContent extends Component {
  
    constructor(props) {
      super(props);
      this.state={
        activeTab:'ElementsToolbar'
      }      
    }
      
    render(){
        // console.log('builderObject==',this.props.builderObject)
        return(
            <>
            <nav id="splitView_sidebar">
                        {/* <div className="toggleFolSplitView">
                            <a className="cursor-pointer" id="sidebarCollapse">
                            </a>
                        </div> */}
                          <div className="filter_Box dataTables_wrapper">
                            <div className="filter_Body p-3 ">
                            {/* <div className="shadow-none border w-100 card mb-0">  */}
                                {
                                    this.props.pageFrom === 'Email'?
                                    <div className="card-body pb-0">
                                        <div className="htmlbuilder-card" style={{width:'100%'}}>
                                            <LeftContainer {...this.props.builderObject} /> 
                                        </div>
                                    </div>
                                    :
                                    <></>
                                }

                                {
                                    this.props.pageFrom === 'Manual Window'?
                                    <div className="card-body pb-0">
                                        <div className="htmlbuilder-card"  style={{width:'100%'}}>
                                            <VariablesList {...this.props.builderObject} /> 
                                        </div>
                                    </div>
                                    :
                                    <></>
                                }

                                {
                                    this.props.pageFrom === 'PDF'?
                                    <div className="card-body pb-0">
                                        <div className="htmlbuilder-card">
                                            {
                                                this.props.builderObject.pdfDetails && this.props.builderObject.pdfDetails.is_variable_mapping && this.props.builderObject.pdfDetails.is_variable_mapping === true ?
                                                <PdfTagList {...this.props.builderObject} /> 
                                                :
                                                <PdfWindowFieldTagList {...this.props.builderObject} />
                                            }
                                        </div>
                                    </div>
                                    :
                                    <></>
                                }
                                                
                                {/*<div className="filter_Box dataTables_wrapper bg-light">
                                <div className="filter_Header">
                                    
                                </div>
                                <div className="filter_Body p-3 ">
                                    
                                </div>
                                <div className="filter_Footer">
                                    
                                </div>
                                
                                </div>*/}
                            </div>
                            {/* </div> */}
                          </div>
        </nav>
               

            </>
        )
    }
}  

export default RightSideBarContent;